import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel border border-dashed rounded-3 px-8 border-gray-300 mb-5" }
const _hoisted_2 = { class: "d-flex flex-row justify-content-between align-items-center py-5" }
const _hoisted_3 = { class: "title d-flex flex-column justify-content-start" }
const _hoisted_4 = { class: "d-flex flex-row align-items-center gap-4" }
const _hoisted_5 = { class: "d-flex flex-row align-items-center" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2 fs-7 lh-1" }
const _hoisted_8 = { class: "m-0 text-gray-400 fs-7" }
const _hoisted_9 = { class: "svg-icon svg-icon-4 svg-icon-primary ms-2" }
const _hoisted_10 = { class: "text-gray-400 fs-7 m-0" }
const _hoisted_11 = { class: "tools d-flex flex-row justify-content-end align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-0" }, null, -1)
const _hoisted_13 = { class: "row align-items-start gy-5 py-5" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "m-0 fs-6 lh-1" }
const _hoisted_16 = { class: "text-gray-400 fs-7" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "m-0 fs-6 lh-1" }
const _hoisted_19 = { class: "text-gray-400 fs-7" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "m-0 fs-6 lh-1" }
const _hoisted_22 = { class: "text-gray-400 fs-7" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "m-0 fs-6 lh-1" }
const _hoisted_25 = { class: "text-gray-400 fs-7" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "m-0 fs-6 lh-1" }
const _hoisted_28 = { class: "text-gray-400 fs-7" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "m-0 fs-6 lh-1" }
const _hoisted_31 = { class: "text-gray-400 fs-7" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "m-0 fs-6 lh-1" }
const _hoisted_34 = { class: "text-gray-400 fs-7" }
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = { class: "m-0 fs-6 lh-1" }
const _hoisted_37 = { class: "text-gray-400 fs-7" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = { class: "m-0 fs-6 lh-1" }
const _hoisted_40 = { class: "text-gray-400 fs-7" }
const _hoisted_41 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_42 = { class: "m-0 fs-6 lh-1" }
const _hoisted_43 = { class: "text-gray-400 fs-7" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "m-0 fs-6 lh-1" }
const _hoisted_46 = { class: "text-gray-400 fs-7" }
const _hoisted_47 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_48 = { class: "m-0 fs-6 lh-1" }
const _hoisted_49 = { class: "text-gray-400 fs-7" }
const _hoisted_50 = { class: "col-md-4" }
const _hoisted_51 = { class: "m-0 fs-6 lh-1" }
const _hoisted_52 = { class: "text-gray-400 fs-7" }
const _hoisted_53 = { class: "col-md-4" }
const _hoisted_54 = { class: "m-0 fs-6 lh-1" }
const _hoisted_55 = { class: "text-gray-400 fs-7" }
const _hoisted_56 = {
  key: 0,
  class: "separator separator-dashed mb-0"
}
const _hoisted_57 = {
  key: 1,
  class: "d-flex flex-row justify-content-end align-items-center py-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.information.common.address")) + " " + _toDisplayString(_ctx.index + 1), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.getStatus(_ctx.data.identification.kyc_status).value.color])
            }, _toDisplayString(_ctx.data.identification.kyc_status_text), 3),
            (_ctx.data.identification.kyc_status == _ctx.KycDisplayStatus.Rejected)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t("kyc.information.common.rejectReason")), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.data.identification.kyc_reject_info?.comments), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("kyc.information.common.rejectOperator")) + ": " + _toDisplayString(_ctx.data.identification.kyc_reject_info?.operator_name), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _renderSlot(_ctx.$slots, "after-title")
        ]),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("kyc.information.common.updateBy")) + ": " + _toDisplayString(_ctx.data.updated_by) + " | " + _toDisplayString(_ctx.$t("kyc.information.common.updateDate")) + ": " + _toDisplayString(_ctx.formatUtcDate(_ctx.data.updated_at, "YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _renderSlot(_ctx.$slots, "toolbar")
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      (_ctx.type === _ctx.KycType.Juridical)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.data.identification.tax_identification_type == 'simple')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.data.identification.vat_id || "--"), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("kyc.information.taxInformation.vatId")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.data.identification.tax_registration_country || "--"), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("kyc.information.taxInformation.taxRegistrationCountry")), 1)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.data.identification.registered_company_name +
                  " " +
                  _ctx.data.identification.company_legal_form || "--"), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("kyc.information.taxInformation.registeredCompanyName")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.data.identification.vat_id || "--"), 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("kyc.information.taxInformation.vatId")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.data.identification.local_tax_authority || "--"), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("kyc.information.taxInformation.localTaxAuthority")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.data.identification.address1 || "--"), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("kyc.address.street")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.data.identification.address2 || "--"), 1),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("kyc.address.houseNo")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.data.identification.postcode || "--"), 1),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("kyc.address.postalCode")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.data.identification.country || "--"), 1),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("kyc.address.country")), 1)
                  ]),
                  (_ctx.data.identification.country_code === 'CN')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.data.identification.province || "--"), 1),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("kyc.address.province")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.data.identification.city || "--"), 1),
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("kyc.address.city")), 1)
                  ]),
                  (_ctx.data.identification.country_code === 'CN')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.data.identification.district || "--"), 1),
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("kyc.address.district")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.type === _ctx.KycType.Natural)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.data.identification.tax_id || "--"), 1),
              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("kyc.information.taxInformation.taxId")), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.data.identification.tax_registration_country || "--"), 1),
              _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("kyc.information.taxInformation.taxRegistrationCountry")), 1)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_56))
      : _createCommentVNode("", true),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ]))
}